import React from "react";
import AntdSpace from 'antd/lib/space';
import {withError} from '@fishx/tracker';

const Space = (props) => <AntdSpace {...props} />

Space.displayName = 'Space';
export default withError(Space);



// WEBPACK FOOTER //
// ./src/components/space/index.tsx